import Head from "next/head";
import { Inter } from "next/font/google";
import styles from "@/styles/Home.module.css";
import Slideshow from "@/components/Slideshow";
import Footer from "@/components/Footer";
import Catalogue from "@/components/Catalogue";
import Navbar from "@/components/Navbar";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { logError } from "@/components/logger";

const inter = Inter({ subsets: ["latin"] });

export default function Location() {

  const router = useRouter();
  const [database, setDatabase] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("/api/database");
        if (response.ok) {
          const data = await response.json();
          setDatabase(data.db);
          sessionStorage.setItem("bumpfunDB", JSON.stringify(data.db));
        } else {
          throw new Error("Failed to fetch data");
        }
        const promotionResponse = await fetch("/api/promotion");
        if (promotionResponse.ok) {
          const data = await promotionResponse.json();
          sessionStorage.setItem("specialPromo", data.promotion);
        } else {
          throw new Error("Failed to fetch promotion variable");
        }
      } catch (err) {
        logError("location.fetch", err, {});
      }
    };
    fetchData();
  }, []);

  if (!database) {
    return (
      <>
        <Head>
        <title>Location | Bumpfun</title>
        <meta name="description" content="Location des châteaux gonflables." />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
          <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
          <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
          <link rel="manifest" href="/site.webmanifest" />
        </Head>
        <main className={`${styles.main} ${inter.className}`}>
          <Navbar />
          <div className={[styles.page, styles.rent].join(" ")}>
            <Slideshow url={router.asPath} database={database} />
            <h1>En cours de chargement...</h1>
            <div className={styles.loadingPlaceholder}></div>
          </div>
          <Footer />
        </main>
      </>
    );
  }

  return (
    <>
      <Head>
      <title>Location | Bumpfun</title>
      <meta name="description" content="Location des châteaux gonflables." />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
        <link rel="manifest" href="/site.webmanifest" />
      </Head>
      <main className={`${styles.main} ${inter.className}`}>
        <Navbar />
        <div className={[styles.page, styles.rent].join(" ")}>
          <Slideshow url={router.asPath} database={database} />
          <h1>Offre Chateaux gonflables</h1>
          <p>
          Nous disposons d&apos;une grande gamme de châteaux gonflables. Montage et démontage sur place.
          </p>
          <p>Nous livrons gratuitement dans un rayon de 20 km autours de Beersel.</p>
          <p className={styles.priceIn}>
          Le montage et démontage sont inclus dans le prix.
          </p>
          <div className={styles.catalogueBox}>
            <Catalogue type="rent" content="castle" title={"Châteaux gonflables"} database={database} link="/fr/location-plusieurs" linkText="Vous souhaitez réserver plusieurs châteaux à la fois?" />
          </div>
          <div className={styles.catalogueBox}>
            <Catalogue type="rent" content="game" title={"Jeux interactives"} database={database} />
          </div>
          <div className={styles.catalogueBox}>
            <Catalogue type="rent" content="other" title={"Autres"} database={database} />
          </div>
          <div className={styles.catalogueBox}>
            <Catalogue type="rent" content="darts" title={"Support et cible de fléchettes"} shoutout="En collaboration avec notre partenaire TOPS." database={database} />
          </div>
          <div className={styles.catalogueBox}>
            <Catalogue type="rent" content="tent" title={"Tonnelles"} shoutout={"En collaboration avec notre partenaire Fantentic."} database={database} />
          </div>
        </div>
        <p className={styles.btw}>*Les prix affichés sont hors TVA.</p>
        <Footer />
      </main>
    </>
  );
}
